import React from "react";

const SchemaModulesContext = React.createContext([]);
export default SchemaModulesContext;
